/**
 * @copyright 2019 @ DigiNet
 * @author THANHTRAM
 * @create 2019/06/03 14:00
 * @update 2019/06/03 14:00
 */

import * as types from './types.js';
import Api from '../services/api.js';

export function loadW17F0005(param, cb) {
    return (dispatch) => {
        // console.log("============== listCompany -> param: ", param);
        Api.put('/w17f0005/grid-mail-history', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadW17F0005Complete(result.data));
                }
            });
    };
}

function loadW17F0005Complete(data) {
    return {
        type: types.W17_W17F0005_DATAGRID_COMPLETE,
        dataGrid: data
    };
}

